import { MatchStatus } from 'app/api/services/matches/match-status/types';

import { URL } from '../../../constants';
import { httpApiService } from '../../../utils/create-http-api-service';
import { defaultRequestService } from '../../../utils/default-request-service';

// ---

export const getMatchStatus = (
  matchId: number,
) => {
  type AdapterProps = { response: MatchStatus };
  const url = `${URL.MATCH_STATUS}/${matchId}`;

  return defaultRequestService<AdapterProps>(url, httpApiService.get);
};
